import { Component, OnInit, Input } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { CurrentUser } from '../current-user.model';
import { CurrentUserService } from "../current-user.service";

@Component({
    selector: 'current-user',
    templateUrl: './current-user.component.html',
    styleUrls: ['./current-user.component.css']
})

export class CurrentUserComponent implements OnInit {

    public get currentUser(): CurrentUser {
        return this.currentUserService.user;
    }

    constructor(private currentUserService: CurrentUserService) {
    }

    ngOnInit(): void {
    }

}



// WEBPACK FOOTER //
// ./src/app/security/current-user/current-user.component.ts